define.alias("ember-cli-string-helpers/helpers/humanize", "calendar/helpers/humanize");